module.exports = __webpack_public_path__ + "static/better-employee-04-1080w-737dbde775d1c66c5ca39ac2fc073779.jpg";